import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTijdelijkeWoning = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="m18 8 10 8v16H8V16z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M16 22h-6v10h6z"
    />
    <path
      fill="#B2E8B0"
      d="M34.91 15.53a6.91 6.91 0 1 1-13.82 0 6.91 6.91 0 0 1 13.82 0"
    />
    <path
      fill="#61D15C"
      d="M28 9.33a6.21 6.21 0 1 0 6.2 6.2 6.2 6.2 0 0 0-6.2-6.2m6.92 6.2a6.92 6.92 0 1 1-13.84.02 6.92 6.92 0 0 1 13.84-.02"
    />
    <path
      fill="#00215C"
      fillRule="evenodd"
      d="M27.55 14.948V11.42h1v4.52l-.797.402-2.38-1.76.594-.804z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M33.17 15h1.17v1h-1.17zM33.25 19.083l-1.02-.59.5-.866 1.02.59zM25.923 20.18l-.59 1.02-.866-.5.59-1.02zM22.35 18.217l1.02-.59.5.866-1.02.59zM31.043 19.68l.59 1.02-.866.5-.59-1.02zM27.55 21.8v-1.18h1v1.18zM25.055 11.327l-.58-1.02.87-.494.58 1.02zM28.55 9.21v1.18h-1V9.21zM30.175 10.833l.58-1.02.87.494-.58 1.02zM33.75 12.793l-1.02.59-.5-.866 1.02-.59zM22.93 16h-1.17v-1h1.17zM22.85 11.927l1.02.59-.5.866-1.02-.59z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m6.935 18.281 7.76-6.28.63.778-7.76 6.28z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgTijdelijkeWoning);

export default ForwardRef;
